/**
 * Registers the service worker from a nonce'd module (no inline script) and hands it the api
 * base for the decline path. In dev (no built worker) registration simply fails and is logged.
 */
import type { Logger } from '../log.js';

export async function registerServiceWorker(apiBase: string, log: Logger, nav: Navigator = navigator): Promise<ServiceWorkerRegistration | null> {
  if (!('serviceWorker' in nav)) return null;
  try {
    const reg = await nav.serviceWorker.register('/sw.js', { scope: '/' });
    const post = (): void => {
      const w = reg.active ?? nav.serviceWorker.controller;
      w?.postMessage({ t: 'ccphone:config', api_base: apiBase });
    };
    if (reg.active) post();
    else nav.serviceWorker.addEventListener('controllerchange', post, { once: true });
    return reg;
  } catch (e) {
    log.warn({ err: (e as Error).message }, 'service worker registration failed');
    return null;
  }
}
